import { useMutation, useQuery } from "@tanstack/react-query";
import { apiGet, apiPut } from "@/lib/apiClient";

export interface MableHomeContentResponse {
  htmlContent: string;
}

export interface UpdateMableHomeContentRequest {
  htmlContent: string;
}

export const mableHomeKeys = {
  content: () => ["mable-home", "resource-content"] as const,
};

export function useMableHomeContent() {
  return useQuery({
    queryKey: mableHomeKeys.content(),
    queryFn: () => apiGet<MableHomeContentResponse>("MableHome/resource-content"),
    staleTime: 30_000,
    refetchOnMount: "always",
  });
}

export function useUpdateMableHomeContent() {
  return useMutation({
    mutationFn: (body: UpdateMableHomeContentRequest) =>
      apiPut<UpdateMableHomeContentRequest, MableHomeContentResponse>("MableHome/resource-content", body),
  });
}
